export const state = {
  rooms: ['Кухня', 'Гостиная', 'Спальня', 'Детская']
}

export const getters = {

}

export const mutations = {

}

export const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
